<template>
  <div class="sidebar-wrapper h-full flex flex-col z-10">
    <ul class="pt-5">
      <a href="#" class="menu-item flex items-center">
        <img src="@/assets/admin-icon/menu/search-white.svg" class="icon mr-2 default-icon">
        <img src="@/assets/admin-icon/menu/search_active.svg" class="icon mr-2 active-icon">
        <span class="text-white">Search</span>
      </a>
      <a href="#" class="menu-item flex items-center h-11" :class="{ active: whenRouterEqual('schools-management') }"
        @click="$router.push({ path: '/' })">
        <img src="@/assets/admin-icon/menu/school-white.svg" class="icon mr-2 default-icon">
        <img src="@/assets/admin-icon/menu/school_active.svg" class="icon mr-2 active-icon">
        <span class="text-white">School management</span>
      </a>
      <a href="#" @click="$router.push({ path: '/system-notification' })" class="menu-item flex items-center h-11">
        <img src="@/assets/admin-icon/menu/communication-white.svg" class="icon mr-2 default-icon">
        <img src="@/assets/admin-icon/menu/communication-active.svg" class="icon mr-2 active-icon">
        <span class="text-white">System Communication</span>
      </a>
      <a href="#" @click="$router.push({ path: '/user-management' })" class="menu-item flex items-center h-11"
        :class="{ active: whenRouterEqual('user-management') }">
        <img src="@/assets/admin-icon/menu/users.svg" class="icon mr-2 default-icon">
        <img src="@/assets/admin-icon/menu/users_active.svg" class="icon mr-2 active-icon">
        <span class="text-white">User Management</span>
      </a>
      <a href="#" class="menu-item flex items-center h-11">
        <img src="@/assets/icons/menu_icons/settings-white.svg" class="icon mr-2 default-icon">
        <img src="@/assets/icons/menu_icons/settings_active.svg" class="icon mr-2 active-icon">
        <span class="text-white">Settings</span>
      </a>
    </ul>

    <div class="sidebar-footer">
      <button class="btn-logout" @click="logOut()">Logout</button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Sidebar',
  components: {

  },
  methods: {
    whenRouterEqual(label) {
      let vm = this;
      if (vm.$route.name == label) {
        return true;
      }
      return false;
    },
    logOut() {
      let vm = this;
      vm.$localStorage.remove("logged_user_data");
      vm.$router.push({ path: "/login" });
    },
  }
}
</script>

<style lang="scss" scoped>
.sidebar-wrapper {
  background: #010404;
  padding: 65px 0px;
  width: 230px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ul {
    .menu-item {
      padding: 8px 15px;
      border-radius: 6px;
      margin: 2px 8px;
      transition: all 0.3s ease;
      cursor: pointer;
      position: relative;

      // Default state - show default icon
      .default-icon {
        display: block;
      }

      .active-icon {
        display: none;
      }

      // Hover effect
      &:hover {
        background: linear-gradient(135deg, #1E1E1E 0%, #2A2A2A 100%);
        transform: translateX(4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

        .default-icon {
          display: none;
        }

        .active-icon {
          display: block;
        }

        span {
          color: #ffffff !important;
          font-weight: 500;
        }
      }

      // Active state
      &.active {
        background: linear-gradient(135deg, #1E1E1E 0%, #2A2A2A 100%);
        border-left: 3px solid #4F46E5;

        .default-icon {
          display: none;
        }

        .active-icon {
          display: block;
        }

        span {
          color: #ffffff;
          font-weight: 600;
        }
      }

      .icon {
        width: 20px;
        height: 20px;
        transition: all 0.3s ease;
      }

      span {
        transition: all 0.3s ease;
        font-size: 14px;
      }
    }
  }

  .sidebar-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15px;

    .btn-logout {
      color: #fff;
      background: transparent;
      border: 1px solid #4F46E5;
      padding: 8px 16px;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.3s ease;
      font-size: 14px;
      width: 100%;

      &:hover {
        background: #4F46E5;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
      }
    }
  }
}
</style>
